import { DropDownList } from "@progress/kendo-react-dropdowns";
import { FieldRenderProps } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { FunctionComponent } from "react";
import { UserApi } from "../../../redux/api/UserApi";

const RoleList: FunctionComponent<FieldRenderProps> = props => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        type,
        optional,
        value,
        uid,
        showHint,
        roleId,
        ...others
    } = props;

    const { data: roles, isFetching } = UserApi.useGetRolesQuery(uid, { skip: !uid });
    const defaultRole = roles?.filter(r => r.Default_Role);
    const selectedRole = roles?.filter(r => r.Role_id === roleId);
    const currentValue = (selectedRole?.length ? selectedRole[0] : undefined) || (defaultRole?.length ? defaultRole[0] : undefined)
    return (
        <>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}>
                {label}
            </Label>
            <div className={"k-form-field-wrap"}>
                <DropDownList {...others} loading={isFetching} value={currentValue} data={roles} dataItemKey="Role_id" textField="Role_Name" popupSettings={{ className: 'z500', width: 300 }} style={{ maxWidth: 200 }} />
            </div>
        </>
    )
}

export default RoleList;